<div *ngIf="isContract()">
  <div>
    <span class="font-app-bold text-darkest text-sm md:text-base">
      {{ "generalOptions.title" | translate }}
    </span>
  </div>
</div>
<div class="flex justify-between py-2 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.formula" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.formulasAndOptionsInformations.formulaName }}
  </span>
</div>
<div class="flex justify-between py-2 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.capital" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.formulasAndOptionsInformations.caracteristics[0].value | currency: "EUR" : "symbol" : "1.0" : "fr" }}
  </span>
</div>
<!--Objet de valeur pour Confort+-->
<div>
  <div>
    <div class="flex w-full">
      <div class="w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
          {{ details.formulasAndOptionsInformations.caracteristics[1].label }}
        </span>
      </div>
      <p class="w-full text-right text-darkest">
        @if (details.formulasAndOptionsInformations?.caracteristics[1]?.value === "0") {
          {{ "optionsList.noValuableObject" | translate }}
        } @else {
          {{
            details.formulasAndOptionsInformations?.caracteristics[1]?.value | currency: "EUR" : "symbol" : "1.0" : "fr"
          }}
        }
        <!-- @if (details.formulasAndOptionsInformations?.caracteristics[1]?.pricedAmountTTC !== null) {
          <span>
            (+{{
              details.formulasAndOptionsInformations?.caracteristics[1]?.pricedAmountTTC
                | currency: "EUR" : "symbol" : "" : "fr"
            }}{{ "optionsList.month" | translate }})
          </span>
        } -->
        <!-- @if (
          details.formulasAndOptionsInformations?.caracteristics[1]?.isIncluded &&
          details.formulasAndOptionsInformations?.caracteristics[1]?.pricedAmountTTC === null
        ) {
          {{ "optionsList.included" | translate }}
        } -->
      </p>
    </div>
  </div>
  <div></div>
</div>

<!--Options souscrites ou non-->
<div *ngFor="let item of details.formulasAndOptionsInformations.options">
  <ng-container *ngIf="item.type === options.PJ || item.type === options.PJSOL">
    <div class="flex items-end mt-3">
      <div class="items-center justify-between w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
          {{ "optionsList.PJOption" | translate }}
        </span>
      </div>
      <span class="text-sm md:text-base font-app-regular text-darkest">
        {{ (!item.isSelected ? "generalOptions.no" : "generalOptions.yes") | translate }}
      </span>
    </div>
  </ng-container>

  <ng-container *ngIf="item.type === options.RCS">
    <div class="flex items-end mt-3">
      <div class="items-center justify-between w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
          {{ "optionsList.schoolOption" | translate }}
        </span>
      </div>
      <span class="text-sm md:text-base font-app-regular text-darkest">
        {{ (!item.isSelected ? "generalOptions.no" : "generalOptions.yes") | translate }}
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="item.type === options.VELO && item.isSelected === true">
    <div class="flex items-end mt-3">
      <div class="items-center justify-between w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
          {{ "optionsList.bikeOption" | translate }}
        </span>
      </div>
      <span class="text-sm md:text-base font-app-regular text-darkest">
        {{ "generalOptions.yes" | translate }}
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="item.type === options.ANO && item.isSelected === true">
    <div class="flex items-end mt-3">
      <div class="items-center justify-between w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
          {{ "optionsList.NomadProtect" | translate }}
        </span>
      </div>
      <span class="text-sm md:text-base font-app-regular text-darkest">
        {{ "generalOptions.yes" | translate }}
      </span>
    </div>
  </ng-container>
</div>

<div
  *ngIf="isContract()"
  class="flex items-end mt-3">
  <div class="items-center justify-between w-full">
    <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
      "lessorInformations.sendCertificate" | translate
    }}</span>
  </div>
  <span class="text-sm md:text-base font-app-regular text-darkest">
    {{
      (!details.optionalServicePolicyVm.sendCertificationOption ? "generalOptions.no" : "generalOptions.yes")
        | translate
    }}
  </span>
</div>
<p-divider type="solid"></p-divider>

